export default __webpack_public_path__ + "77ce8d51cf456d84b5abfb5ae55e1d4a.svg";